import './confirmation-code-input.css'

import PropTypes from 'prop-types'
import VerificationInput from 'react-verification-input'
import { cn } from '@/lib/utils'

function ConfirmationCodeInput({ code, setCode, length, onFocus }) {
  return (
    <VerificationInput
      value={code}
      validChars="0-9"
      placeholder="0"
      length={length}
      onChange={setCode}
      onFocus={onFocus}
      inputProps={{
        inputMode: 'numeric',
        autoComplete: 'one-time-code',
      }}
      classNames={{
        container: 'flex flex-row justify-between gap-1.5 md:gap-2 p-0 w-full h-full', // keep tight gaps on small screens
        character: cn(
          'flex items-center justify-center rounded-md border border-input font-medium',
          'w-[40px] h-[40px] text-3xl',
          'max-[360px]:w-[36px] max-[360px]:h-[36px] max-[360px]:text-2xl',
          'max-[320px]:w-[32px] max-[320px]:h-[32px] max-[320px]:text-xl',
          'md:w-[64px] md:h-[64px] md:text-[40px]',
          code ? '' : 'text-gray-300'
        ),
        characterInactive: 'bg-inherit text-gray-300',
        characterSelected: 'outline-brand-600 text-[--neutral-700] character--selected shadow-[0_0px_12px_#5A8090]',
        characterFilled: 'outline outline-2 outline-brand-500 text-[--neutral-700] character--filled',
      }}
    />
  )
}

ConfirmationCodeInput.propTypes = {
  code: PropTypes.string,
  setCode: PropTypes.func,
  length: PropTypes.number,
  onFocus: PropTypes.func,
}

export { ConfirmationCodeInput }
